module.exports = __webpack_public_path__ + "static/media/ally_pro_web_3.9fd588bf.jpg";